// extracted by mini-css-extract-plugin
module.exports = {"link":"DocumentsLinksComponent_link__rg5bM","nfumDocumentLinkContainer":"DocumentsLinksComponent_nfumDocumentLinkContainer__9iiyy"};